import { combineReducers, configureStore } from "@reduxjs/toolkit";
import hotelReducer from "./slices/hotel"; 
import carPackageReducer from "./slices/carrentalpackage";
import tourPackageReducer from "./slices/tourpackage";
import authReducer from "./slices/auth";
import bookingReducer from "./slices/booking"




const rootReducer = combineReducers({
  hotel: hotelReducer, 
  carPackage:carPackageReducer,
  tourPackage:tourPackageReducer,
  auth: authReducer,
   booking: bookingReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});


export default store;
